import { createStore, combineReducers } from 'redux';
import pageReducer from './page/reducer';
import authReducer from './auth/reducer';
import beforeGameReducer from './beforeGameTabs/reducer';
import afterGameReducer from './afterGameTabs/reducer';
import loginPopupReducer from './loginPopup/reducer';
import newSearchReducer from './newSearch/reducer';

const reducers = combineReducers({
	pageReducer,
	authReducer,
	beforeGameReducer,
	afterGameReducer,
	loginPopupReducer,
	newSearchReducer,
});

// preloadedState will be passed in by the plugin
const store = (preloadedState) => {
	const enhancer =
		typeof window !== 'undefined' && process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__
			? window.__REDUX_DEVTOOLS_EXTENSION__()
			: undefined;

	return createStore(reducers, preloadedState, enhancer);
};

export default store;
